// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cc51c94e","455":"06e17046","977":"bb0b0038"}[chunkId] + ".chunk.js";
};